<script>
export default {
  name: 'marketChart',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      myChart: null,
      selectType: 0,
      selectTypeList: [
        {value: 0, label: '马铃薯'},
        {value: 1, label: '大豆'},
        {value: 2, label: '白砂糖'}
      ],
      selectTypeDate: 0,
      selectTypeDateList: [
        {value: 0, label: '近一个月'},
        {value: 1, label: '近三个月'},
        {value: 2, label: '近六个月'},
        {value: 3, label: '近一年'}
      ]
    };
  },
  watch: {
    selectType: {
      handler (val) {
        this.$emit('selectType', val);
      },
      deep: true
    },
    selectTypeDate: {
      handler (val) {
        this.$emit('selectTypeDate', val);
      },
      deep: true
    },
    list: {
      handler: function (val) {
        if (val.length) {
          this.initChart();
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    initChart () {
      const myChart = this.$echarts.init(document.getElementById('marketChart'));
      let data = this.list.map(item => {
        item.timeInt = String(item.timeInt);
        let year = item.timeInt.substring(0, 4);
        let month = item.timeInt.substring(4, 6);
        let date = item.timeInt.substring(6, 8);
        let time = +new Date([year, month, date].join('-'));
        if (this.selectType === 0) {
          return [
            time, item['平均价']
          ];
        } else {
          return [
            time, item['全国']
          ];
        }
      });
      const option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          },
          padding: 0,
          backgroundColor: 'transparent',
          borderWidth: 0,
          formatter: function (params) {
            let timeData = params[0].data[0];
            let month = new Date(timeData).getMonth() + 1 < 10 ? '0' + (new Date(timeData).getMonth() + 1) : new Date(timeData).getMonth() + 1;
            let date = new Date(timeData).getDate() < 10 ? '0' + new Date(timeData).getDate() : new Date(timeData).getDate();
            let time = new Date(timeData).getFullYear() + '-' + month + '-' + date;
            let res = '';
            res += `
                <div style="width: 140px;height: 50px;border-radius: 2px;padding: 0;background-color:rgba(0,0,0,0.502);color: #fff;">
                   <div style="padding-left: 10px;padding-top: 4px">
                      ${time}
                   </div>
                   <div style="padding-left: 10px">
                      <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#EE4533"></span>
                      <span>一级：${params[0].data[1]}</span>
                  </div>
                </div>
            `;
            return res;
          }
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#EE4533'
            },
            // areaStyle: {
            //   color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     {
            //       offset: 0,
            //       color: 'rgba(238,69,51,0.12)'
            //     },
            //     {
            //       offset: 1,
            //       color: 'rgba(238,69,51,0)'
            //     }
            //   ])
            // },
            data: data
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    }
  }
}
;
</script>

<template>
  <div class="market-chart">
    <header>
      <div class="top-name">
        <h2>现货行情指数</h2>
        <div class="right-select-boxs">
          <Select v-model="selectType" style="width: 150px;">
            <Option v-for="item in selectTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Select v-model="selectTypeDate" style="width: 150px; margin-left: 10px;">
            <Option v-for="item in selectTypeDateList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
      </div>
    </header>
    <div id="marketChart" style="width: 100%;height: 100%;"></div>
    <div class="tipMeasureUnit">单位：元/吨</div>
  </div>
</template>

<style scoped lang="scss">
.market-chart {
  width: 580px;
  height: 265px;
  padding: 20px;
  background-color: #fff;
  position: relative;

  .top-name {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .right-select-boxs {
      display: flex;
      align-items: center;
    }
  }

  .tipMeasureUnit {
    position: absolute;
    top: 70px;
    right: 70px;
    z-index: 99;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/marketChart.vue